export const SUPPORT_FLAGS = [
  { slug: 'idv_help', label: 'IDV Help', icon: 'id-card' },
  { slug: 'manual_process', label: 'Manual Process', icon: 'gears' },
  { slug: 'outbound_call', label: 'Outbound Call', icon: 'phone' },
  { slug: 'image_help', label: 'Image Help', icon: 'image' },
  {
    slug: 'candidate_email_failed',
    label: 'Candidate Email Failed',
    icon: 'envelope',
  },
  {
    slug: 'provider_email_failed',
    label: 'Provider Email Failed',
    icon: 'envelope',
  },
];

export const SUPPORT_FLAG_FILTER_OPTIONS = SUPPORT_FLAGS.map(({ slug, label }) => ({
  name: label,
  value: slug,
}));

export const parseSupportFlags = value => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const toggleSupportFlag = (current, slug) => {
  const flags = parseSupportFlags(current);
  const next = flags.includes(slug) ? flags.filter(flag => flag !== slug) : [...flags, slug];
  return next.length ? next : null;
};
